'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var merchandiseSelector = exports.merchandiseSelector = function merchandiseSelector(_ref) {
  var merchandise = _ref.merchandise;
  return merchandise;
};


//////////////////
// WEBPACK FOOTER
// ./js/selectors/MerchandiseSelectors.js
// module id = 160
// module chunks = 3 4 5